<div class= "gestionbox">
    <div class="gestionButtons">
        <button (click)="openDialog()">
        Alta nuevo contratista
        </button>
        <button (click)="openDialogNewCentro()">
        Petición nuevos centros
        </button>

    </div>

    <div class="tab-boxgest">
        <div class="displayFlexEvenly">
            <div class="gestion">
                <h2 class="title-tab">Documentación Obligatoria Centros Productores</h2>
                <ul>
                    <li>
                        <span class="point"></span>
                        Comunicación actividad productora Residuos Peligrosos
                    </li>
                    <li>
                        <span class="point"></span>
                        Comunicación actividad productora Residuos No Peligrosos
                    </li>
                    <!-- <li>
                        <span class="point"></span>
                        Informe trimestral de residuos
                    </li> -->
                    <li>
                        <span class="point"></span>
                        Contrato de tratamiento con gestor
                    </li> 
                    <li>
                        <span class="point"></span>
                        Autorización Gestor
                    </li>  
                    <li>
                        <span class="point"></span>
                        Autorización Transportista
                    </li>                       
                </ul>
            </div>
            <div class="gestion">
                <h2 class="title-tab">Documentación Obligatoria Contratistas</h2>
                <ul>
                    <li>
                        <span class="point"></span>
                        Certificado de estar al corriente en las Obligaciones de la Seguridad Social
                    </li>
                    <li>
                        <span class="point"></span>
                        Certificado de estar al corriente de sus obligaciones tributarias
                    </li>                
                </ul>
            </div>
        </div>
        <div >
            <div class="gestion">
                <h2 class="title-tab">Documentación Adicional Centros Productores</h2>
                <p>A continuación puede añadir la documentación adicional que desee solicitar a todos los Centros Productores que le presten servicio:<br> (un máximo de 3 documentos)</p>
                <p style="color: red; font-size: 13px;">No olvide "solicitar los documentos" después de añadir o eliminar los documentos que desee solicitar.</p>
                <form [formGroup]="documentoAdicional">
                       
                        <mat-form-field appearance="outline" >
                         <mat-label>Nombre del documento</mat-label>
                            <input matInput type="text" name="nombre" [(ngModel)]="documento" formControlName="nombreArchivo" maxlength="20"/>
                        </mat-form-field>
                        <p style="color: red; margin-top: -1rem; font-size: 12px; margin-bottom: 1.5rem;">(Máximo 20 caracteres)</p>
                    
                        <mat-form-field appearance="outline">
            
                            <mat-label>Periocidad</mat-label>
                            <mat-select name="periocidad" [(value)]="periodoSeleccionado" (selectionChange)="selectPeriodo($event.value)" formControlName="periodo">
                              <mat-option *ngFor="let periodo of periodos" [value]="periodo" >
                             {{periodo}}
                              
                              </mat-option>
                            
                          </mat-select>
                          </mat-form-field>
                        <button type="submit" (click)="addDocAdicional(documento)" *ngIf= "docFirstTime.length < 3" [disabled]="documentoAdicional.invalid" >
                            Añadir
                        </button>
                        <button type="submit" (click)="addDocAdicional(documento)" *ngIf="docFirstTime.length == 3" disabled style="background-color: gray; cursor: none;">
                            Añadir
                        </button>
            </form>
            <div>
                <ul *ngFor="let doc of docAdicional">
                    <li *ngIf="doc.firstTime"><img src="./../../../../assets/trash.png" alt="" role="button" (click)="handleClickDelete(doc.id)">  <span class="point" style="margin-left: 10px;"></span> {{doc.nombreArchivo}} ({{doc.periocidad}})</li>
                </ul>
            </div>

            <button (click)="handleClickSolicitar()" class="btn-solicitarCentros">Solicitar Documentos</button>
            </div>
        </div>
    </div>
</div>